
export class BeforeSubmitArgs {
  results: Array<Promise<boolean>> = [];

  public add(callback: () => Promise<boolean>) {
    this.results.push(callback());
  }

  public async waitForResult() {
    for(const result of this.results) {
      if (!await result)
        return false;
    }
    return true;
  }
}
